import { render, staticRenderFns } from "./subDeviceDetail.vue?vue&type=template&id=084dfc26&scoped=true&"
import script from "./subDeviceDetail.vue?vue&type=script&lang=js&"
export * from "./subDeviceDetail.vue?vue&type=script&lang=js&"
import style0 from "./subDeviceDetail.vue?vue&type=style&index=0&id=084dfc26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084dfc26",
  null
  
)

export default component.exports